import TomSelect from 'tom-select';
import { computePosition, offset, flip, shift } from '@floating-ui/dom';
import { gsap } from 'gsap';

function handleDropdownOpen() {
  const parent = this.control.parentElement.parentElement;
  const placement = parent.dataset.dropdownPlacement || 'bottom';
  computePosition(this.control, this.dropdown, {
    middleware: [offset(8), flip(), shift({ padding: 20 })],
    placement,
  }).then(({ x, y, placement }) => {
    console.log({ placement });
    this.control.parentElement.dataset.dropdownPlacement = placement;

    gsap.set(this.dropdown, {
      left: x,
      top: y,
    });
    gsap.fromTo(
      this.dropdown,
      { y: -5, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, duration: 0.3, ease: 'power3.out' },
    );
  });
}

function handleDropdownClose() {
  gsap.to(this.dropdown, {
    y: -5,
    autoAlpha: 0,
    duration: 0.25,
    ease: 'power3.out',
  });
}

export function initSelect(parent) {
  if (!parent) return;

  const select = parent.querySelector('select');
  if (!select) return;

  const hasSearch = parent.classList.contains('select--has-search');
  const doShowValue = parent.classList.contains('select--do-show-value');

  let settings = {
    controlInput: null,
    copyClassesToDropdown: false,
    allowEmptyOption: true,
    maxOptions: false,
    onDropdownOpen: handleDropdownOpen,
    onDropdownClose: handleDropdownClose,
  };

  if (hasSearch) settings.plugins = ['dropdown_input'];

  if (doShowValue) {
    settings.render = {
      item: (data, escape) => {
        return `<div>${escape(data.value.toUpperCase())}</div>`;
      },
    };
  }

  new TomSelect(select, settings);
}

export function initSelects(selector = '.select') {
  const selects = document.querySelectorAll(selector);
  selects.forEach((select) => initSelect(select));
}
